import { createContext, useContext } from "react";
import invariant from "tiny-invariant";
import type { EventStoreContextValue } from "./EventStoreProvider";

export const EventStoreContext = createContext<EventStoreContextValue | null>(null);

export function useEventStore() {
  const context = useContext(EventStoreContext);
  invariant(context, "`useEventStore` must be used within a `EventStoreProvider`");
  return context;
}
